<template>
  <!-- Le card dei piani dentro a una modale: le formule dello stesso piano
       stanno in una card sola. Prima qui c'erano immagini con nome e prezzo
       disegnati dentro, che invecchiavano a ogni cambio di listino. -->
  <div>
    <div class="plan-sheets">
      <PlanSheet
        v-for="gruppo in gruppi"
        :key="gruppo.map((p) => p.slug).join('|')"
        :piani="gruppo"
        :slug-corrente="slugCorrente"
        :tutte-le-condizioni="gruppo[0] === gratuito"
        :compattabile="gruppi.length > 1"
      />
    </div>
    <p v-if="conAsterisco" class="plan-sheets__note">{{ $t("PlanSheet.notaAsterisco") }}</p>
  </div>
</template>

<script>
import PlanSheet from "@/app/modules/sottoscrizioni/components/PlanSheet.vue";
import { raggruppaPiani, righeCondizioni } from "@/_utils/pianiSottoscrizione";

export default {
  name: "SubscriptionDetailModal",
  components: { PlanSheet },
  props: {
    // I piani da mostrare, come li manda l'API (con condizioni e dettaglio)
    piani: {
      type: Array,
      default: () => [],
    },
    // Il piano della persona, che prende l'anello
    slugCorrente: {
      type: String,
      default: null,
    },
    // Il piano gratuito di chi non ha una sottoscrizione: nome, prezzo 0 e le
    // condizioni generali dell'API; va in testa e mostra tutte le condizioni
    gratuito: {
      type: Object,
      default: null,
    },
  },
  computed: {
    gruppi() {
      const gruppi = raggruppaPiani(this.piani, this.slugCorrente);
      return this.gratuito ? [[this.gratuito], ...gruppi] : gruppi;
    },
    conAsterisco() {
      return this.gruppi.some((gruppo) =>
        gruppo.some((piano) =>
          righeCondizioni(piano.condizioni, (chiave, valori) => this.$t(chiave, valori), this.$i18n.locale, {
            tutte: piano === this.gratuito,
          }).some((riga) => riga.asterisco)
        )
      );
    },
  },
};
</script>
